const manutencao_veto_transferencia = {
  path: "/manutencao_veto_transferencia",
  redirect: "/manutencao_veto_transferencia",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros por Escola",
  },
  children: [
    {
      path: "/manutencao_veto_transferencia/novo",
      name: "manutencaovetotransferencia_novo",
      meta: {
        allowedPermissions: ["veto_transferencia_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoVetoTransferencia/ManutencaoVetoTransferenciaCad.vue"
        ),
    },
    {
      path: "/manutencao_veto_transferencia/edit/:id",
      name: "manutencaovetotransferencia_atualizar",
      meta: {
        allowedPermissions: ["veto_transferencia_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoVetoTransferencia/ManutencaoVetoTransferenciaEdit.vue"
        ),
    },
    {
      path: "/manutencao_veto_transferencia",
      name: "manutencaovetotransferencia",
      meta: {
        allowedPermissions: ["veto_transferencia_list"],
      },
      component: () =>
        import(
          "@/views/ManutencaoVetoTransferencia/ManutencaoVetoTransferenciaHome.vue"
        ),
    },
  ],
};

export { manutencao_veto_transferencia };
